import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { getToken } from '../../functions/app_functions.js';
import withRouter from '../../with_router.js';
import ForminputDropdown from '../forminput/forminput_dropdown.js';
import { format_price } from '../../functions/functions_formatting.js';
import Destinationcarousel from '../home/destinationcarousel.js';
import { ReactComponent as IconClose } from '../../media/icons/close.svg';
import { ReactComponent as IconLocation } from '../../media/icons/location.svg';
import { ReactComponent as IconCouple } from '../../media/icons/group.svg';
import { ReactComponent as IconDetails } from '../../media/icons/details.svg';
import { ReactComponent as IconArrow } from '../../media/icons/arrow_right.svg';
import { ReactComponent as IconStar } from '../../media/icons/star.svg';


class Search extends Component {
    constructor(props) {
        super(props);
        this.state = {
            page: "",
            updated: false,
            radius_list: [
                10,
                20,
                50,
                100,
                200,
                500,
                1000
            ],
            filters: {
                country: [],
                city: [],
                radius: 50,
                category: [],
                size: [],
                pricing: [],
                timing: [],
                duration: [],
                activities: null,
                following: null
            },
            sort: null,
            data_loaded: false,
            data_loaded_completed: false,
            trip_data: []
        };

        this.baseUrl = this.props.baseUrl;

        this.setPage = this.setPage.bind(this);
        this.setFilter = this.setFilter.bind(this);
        this.setSort = this.setSort.bind(this);
        this.updateData = this.updateData.bind(this);
        this.loadTripsData = this.loadTripsData.bind(this);

        this.addFilterElement = this.addFilterElement.bind(this);
        this.removeFilterElement = this.removeFilterElement.bind(this);
        this.toggleFilterElement = this.toggleFilterElement.bind(this);
        this.updateURL = this.updateURL.bind(this);
        this.updatePicture = this.updatePicture.bind(this);
    }


    async componentDidMount() {
        var filters = {
            country: [],
            city: [],
            radius: 50,
            category: [],
            size: [],
            pricing: [],
            timing: [],
            duration: [],
            activities: null,
            following: null
        };
        const filter_country = this.props.searchParams.get("country") ? this.props.searchParams.get("country").split(",") : [];
        const filter_city = this.props.searchParams.get("city") ? this.props.searchParams.get("city").split(",") : [];
        const filter_radius = this.props.searchParams.get("radius") ? this.props.searchParams.get("radius") : 50;
        const filter_category = this.props.searchParams.get("category") ? this.props.searchParams.get("category").split(",") : [];
        const filter_size = this.props.searchParams.get("size") ? this.props.searchParams.get("size").split(",") : [];
        const filter_pricing = this.props.searchParams.get("pricing") ? this.props.searchParams.get("pricing").split(",") : [];
        const filter_timing = this.props.searchParams.get("timing") ? this.props.searchParams.get("timing").split(",") : [];
        const filter_following = this.props.searchParams.get("following") ? this.props.searchParams.get("following") : null;
        const sort = this.props.searchParams.get("sort") ? this.props.searchParams.get("sort") : null;
        if (filter_country) {
            filters.country = filter_country;
        }
        if (filter_city) {
            filters.city = filter_city;
        }
        if (filter_radius) {
            filters.radius = filter_radius;
        }
        if (filter_category) {
            filters.category = filter_category;
        }
        if (filter_size) {
            filters.size = filter_size;
        }
        if (filter_pricing) {
            filters.pricing = filter_pricing;
        }
        if (filter_timing) {
            filters.timing = filter_timing;
        }
        if (filter_following) {
            filters.following = filter_following;
        }
        await this.updateData(filters, sort);
    }


    async componentDidUpdate() {
        var filters = this.state.filters;
        var sort = this.state.sort;
        await this.updateData(filters, sort);
    }


    capitalizeFirstLetter(str) {
        try {
            return str.charAt(0).toUpperCase() + str.slice(1);
        } catch (error) {
            return str;
        }
    }


    async setPage(page) {
        this.setState({ page: page });
        if (this.state.updated) {
            await this.props.setLoading();
            await this.loadTripsData(this.state.filters);
            this.setState({ updated: false });
            await this.props.unsetLoading();
        }
    }


    async setFilter(filter, value) {
        var filters = this.state.filters;
        filters[filter] = value;
        this.setState({
            filters: filters,
            updated: true
        });
    }


    async setSort(sort) {
        this.setState({ sort: sort });
        await this.updateData(this.state.filters, sort);
    }


    async addFilterElement(label, value) {
        var filters = this.state.filters;
        filters[label].push(value);
        this.setState({
            filters: filters,
            updated: true
        });
    }


    async removeFilterElement(label, value) {
        var filters = this.state.filters;
        filters[label] = filters[label].filter(element => element !== value);
        // Check that enough filters are set
        if (this.checkFilters(filters)) {
            this.setState({
                filters: filters,
                updated: true
            });
        } else {
            var name = "No filters set";
            var message = "Please use filters to tell us what you are looking for. For example, a country or your group size.";
            this.props.setError(name, message);
        }
    }


    async toggleFilterElement(label, value) {
        var filters = this.state.filters;
        if (filters[label].includes(value)) {
            filters[label] = filters[label].filter(element => element !== value);
        } else {
            filters[label].push(value);
        }
        // Check that enough filters are set
        if (this.checkFilters(filters)) {
            this.setState({
                filters: filters,
                updated: true
            });
        } else {
            var name = "No filters set";
            var message = "Please use filters to tell us what you are looking for. For example, a country or your group size.";
            this.props.setError(name, message);
        }
    }


    checkFilters(filters) {
        try {
            var status = false;
            filters.country.length >= 1 ? status = true : status = status;
            filters.city.length >= 1 ? status = true : status = status;
            filters.category.length >= 1 ? status = true : status = status;
            filters.size.length >= 1 ? status = true : status = status;
            filters.pricing.length >= 1 ? status = true : status = status;
            filters.timing.length >= 1 ? status = true : status = status;
            filters.duration.length >= 1 ? status = true : status = status;
            filters.following ? status = true : status = status;
            return status;
        } catch (error) {
            // Track error
            var name = "Web error";
            var message = "Could not check filters. Please check the URL and try again.";
            /* this.props.setError(name, message); */
            // Track event
            this.props.logEvent("Client error", "Trips_checkFilters");
            return false;
        }
    }


    async updateData(filters, sort) {
        if ((JSON.stringify(filters) != JSON.stringify(this.state.filters)) || this.state.data_loaded == false || (sort != this.state.sort)) {
            await this.setState({
                filters: filters,
                sort: sort,
                data_loaded: true
            });
            await this.props.setLoading();
            await this.loadTripsData(filters);
            await this.props.unsetLoading();
        }
    }


    async loadTripsData(filters) {
        try {
            // Send request
            var response = await fetch(this.baseUrl + "/searchtrips", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${getToken()}`
                },
                body: JSON.stringify({
                    filters: filters,
                    sort: this.state.sort
                }),
            });
            // Process response
            response = await response.json();
            var data = response.value;
            // Prepare review data
            data.forEach(trip => {
                if (trip.reviews.length >= 1) {
                    trip.review_average = (trip.reviews.reduce((sum, item) => sum + parseFloat(item.rating), 0) / trip.reviews.length).toFixed(1);
                } else {
                    trip.review_average = null;
                }
            });
            // Filter for following status
            var following_filter = this.state.filters.following;
            if (following_filter == "following") {
                data = data.filter(trip => trip.is_following_user == true);
            }
            if (data && data != null) {
                // Set data to state
                this.setState({
                    trip_data: data,
                    data_loaded_completed: true
                });
                this.updateURL();
                // Track event
                this.props.logEvent("User activity", "Trip search completed");
            } else {
                // Track error
                var name = "Server error";
                var message = "Could not load trip data. Please check the URL and try again.";
                this.props.setError(name, message);
                // Track event
                this.props.logEvent("Client error", "Trips_loadTripsData");
            }
            window.scrollTo(0, 0);
        } catch (error) {
            // Track error
            var name = "Server error";
            var message = "Could not load trip data. Please check the URL and try again.";
            this.props.setError(name, message);
            // Track event
            this.props.logEvent("Client error", "Trips_loadTripsData");
        }
    }


    updateURL() {
        try {
            var filters = {};
            const country = this.state.filters.country;
            const city = this.state.filters.city;
            const radius = this.state.filters.radius;
            const category = this.state.filters.category;
            const size = this.state.filters.size;
            const pricing = this.state.filters.pricing;
            const timing = this.state.filters.timing;
            const following = this.state.filters.following;
            const sort = this.state.sort
            if (country.length >= 1) filters["country"] = country.join(",");
            if (city.length >= 1) filters["city"] = city.join(",");
            if (radius != 50) filters["radius"] = radius;
            if (category.length >= 1) filters["category"] = category.join(",");
            if (size.length >= 1) filters["size"] = size.join(",");
            if (pricing.length >= 1) filters["pricing"] = pricing.join(",");
            if (timing.length >= 1) filters["timing"] = timing.join(",");
            if (following.length != "" && following != null) filters["following"] = following;
            if (sort != "" && sort != null) filters["sort"] = sort;
            const params = new URLSearchParams(filters);
            this.props.goToPage(`trips?${params.toString()}`);
        } catch (error) {
            // Track error
            var name = "Web error";
            var message = "Could not update URL. Please check the URL and try again.";
            /* this.props.setError(name, message); */
            // Track event
            this.props.logEvent("Client error", "Trips_updateURL");
        }
    };


    updatePicture(trip_id, next = true) {
        var data = this.state.trip_data;
        data.map(trip => {
            // Check if this is the trip
            if (trip.trip_id == trip_id) {
                var list = trip.pictures_all;
                if (next) {
                    list.push(list.shift());
                } else {
                    list.unshift(list.pop());
                }
                trip.pictures_all = list;
            }
        });
        this.setState({
            trip_data: data
        })
    }


    render() {

        return (
            <div className="content-container search-container">

                <Helmet>
                    {/* Add the breadcrumb schema as JSON-LD */}
                    <script type="application/ld+json">
                        {`
                            {
                                "@context": "https://schema.org",
                                "@type": "BreadcrumbList",
                                "itemListElement": [
                                {
                                    "@type": "ListItem",
                                    "position": 1,
                                    "name": "Guidr Home",
                                    "item": "https://guidr.net/"
                                },
                                {
                                    "@type": "ListItem",
                                    "position": 2,
                                    "name": "Search itineraries",
                                    "item": "https://guidr.net/trips"
                                }
                                ]
                            }
                        `}
                    </script>
                    <title>
                        {"Discover " + (this.state.sort == "newest" ? "new" : "popular") + " itineraries" + (this.state.filters.city.length >= 1
                            ? (" in " + this.state.filters.city[0])
                            : (this.state.filters.country.length >= 1
                                ? (" in " + this.state.filters.country[0])
                                : "")
                        )
                            + " | Guidr"}
                    </title>
                </Helmet>

                <div className="content-wrapper--wide">
                    <div className="search-wrapper">

                        <div className="search__filters-container">
                            <div onClick={() => this.setPage("country")} className={"search__filters__label" + (this.state.filters.country.length >= 1 ? " search__filters__label--active" : "")}>
                                {this.state.filters.country.length == 0 ? "Country" : this.state.filters.country.length == 1 ? this.state.filters.country[0] : this.state.filters.country.length + " countries"}
                            </div>
                            {(this.state.filters.country.length > 0 || this.state.filters.city.length > 0) &&
                                <div onClick={() => this.setPage("city")} className={"search__filters__label" + (this.state.filters.city.length >= 1 ? " search__filters__label--active" : "")}>
                                    {this.state.filters.city.length == 0 ? "City" : this.state.filters.city.length == 1 ? this.state.filters.city[0] : this.state.filters.city.length + " cities"}
                                </div>
                            }
                            {(this.state.filters.city.length > 0) &&
                                <div onClick={() => this.setPage("radius")} className={"search__filters__label" + ((this.state.filters.radius && this.state.filters.radius != 0) ? " search__filters__label--active" : "")}>
                                    {(!this.state.filters.radius || this.state.filters.radius == 0) ? "Radius" : (this.state.filters.radius + " km radius")}
                                </div>
                            }
                            <div onClick={() => this.setPage("category")} className={"search__filters__label" + (this.state.filters.category.length >= 1 ? " search__filters__label--active" : "")}>
                                {this.state.filters.category.length == 0 ? "Trip category" : this.state.filters.category.length == 1 ? this.state.filters.category[0] : this.state.filters.category.length + " trip categories"}
                            </div>
                            <div onClick={() => this.setPage("size")} className={"search__filters__label" + (this.state.filters.size.length >= 1 ? " search__filters__label--active" : "")}>
                                {this.state.filters.size.length == 0 ? "Target group" : this.state.filters.size.length == 1 ? this.state.filters.size[0] : this.state.filters.size.length + " target groups"}
                            </div>
                            <div onClick={() => this.setPage("pricing")} className={"search__filters__label" + (this.state.filters.pricing.length >= 1 ? " search__filters__label--active" : "")}>
                                {this.state.filters.pricing.length == 0 ? "Pricing" : this.state.filters.pricing.length == 1 ? this.state.filters.pricing[0] : this.state.filters.pricing.length + " pricing categories"}
                            </div>
                            <div onClick={() => this.setPage("timing")} className={"search__filters__label" + (this.state.filters.timing.length >= 1 ? " search__filters__label--active" : "")}>
                                {this.state.filters.timing.length == 0 ? "Timing" : this.state.filters.timing.length == 1 ? this.state.filters.timing[0] : this.state.filters.timing.length + " timing categories"}
                            </div>
                            <div onClick={() => this.setPage("following")} className={"search__filters__label" + (this.state.filters.following != null ? " search__filters__label--active" : "")}>
                                {this.state.filters.following == null && "Following"}
                                {this.state.filters.following == "all" && "From all users"}
                                {this.state.filters.following == "following" && "From users you follow"}
                            </div>
                            <div onClick={() => this.setPage("sort")} className={"search__filters__label" + (this.state.sort != null ? " search__filters__label--active" : "")}>
                                {this.state.sort == null && "Sort"}
                                {this.state.sort == "rated" && "Recommended"}
                                {this.state.sort == "views" && "Most views"}
                                {this.state.sort == "newest" && "Newest"}
                            </div>
                            {/* <div onClick={() => this.setPage("duration")} className={"search__filters__label" + (this.state.filters.duration !== "" ? " search__filters__label--active" : "")}>
                                Duration
                            </div> */}
                            {/* <div onClick={() => this.setPage("activities")} className={"search__filters__label" + (this.state.filters.activities !== "" ? " search__filters__label--active" : "")}>
                                Activities
                            </div> */}
                            {/* <div className="search__filters__label">
                                Public
                            </div> */}
                        </div>

                        <div className="search__results-container">

                            {(this.state.trip_data.length >= 1 || !this.state.data_loaded_completed) && 
                                <div className="search__results__tripcarousel">

                                    {this.state.trip_data.length >= 1 && this.state.trip_data.map((trip, index) => (
                                        ((trip.pictures_all && trip.pictures_all.length >= 1) &&
                                            <div key={index} className="search__results__element">
                                                {trip.collection && trip.collection.length >= 1 &&
                                                    <div className="search__results__element__labelbar">
                                                        {trip.collection.slice(0, 3).map((element, i) => (
                                                            <div key={i} className="search__results__element__labelbar__label">
                                                                {element}
                                                            </div>
                                                        ))}
                                                    </div>
                                                }
                                                {trip.pictures_all && trip.pictures_all.length >= 1 &&
                                                    <div className="tripcarousel__element__picture">
                                                        {trip.pictures_all[0].filepath.endsWith(".mp4") ||
                                                            trip.pictures_all[0].filepath.endsWith(".mov") ||
                                                            trip.pictures_all[0].filepath.endsWith(".avi") ? (
                                                            <video
                                                                src={trip.pictures_all[0].filepath}
                                                                alt={trip.pictures_all[0].label}
                                                                className="tripcarousel__element__picture-inner"
                                                                playsInline
                                                                controls
                                                                muted
                                                                loop
                                                                preload="auto"
                                                            />
                                                        ) : (
                                                            <img
                                                                src={trip.pictures_all[0].filepath}
                                                                alt={trip.pictures_all[0].label}
                                                                className="tripcarousel__element__picture-inner"
                                                            />
                                                        )}
                                                        {trip.pictures_all.length >= 2 &&
                                                            <div onClick={() => this.updatePicture(trip.trip_id, false)} className="tripcarousel__element__picture__navbutton tripcarousel__element__picture__navbutton--left">
                                                                <IconArrow className="tripcarousel__element__picture__navbutton-inner" />
                                                            </div>
                                                        }
                                                        {trip.pictures_all.length >= 2 &&
                                                            <div onClick={() => this.updatePicture(trip.trip_id, true)} className="tripcarousel__element__picture__navbutton tripcarousel__element__picture__navbutton--right">
                                                                <IconArrow className="tripcarousel__element__picture__navbutton-inner" />
                                                            </div>
                                                        }
                                                    </div>
                                                }
                                                <div className="tripcarousel__element__content">
                                                    <div className="tripcarousel__element__contentbox tripcarousel__element__contentbox-title">
                                                        <div className="tripcarousel__element__title">
                                                            <Link to={"/trip/" + trip.trip_id} className="tripcarousel__element__title-inner text-bold">
                                                                {trip.title}
                                                            </Link>
                                                        </div>
                                                        <div className="tripcarousel__element__review">
                                                            {trip.review_average &&
                                                                <>
                                                                    <IconStar className="tripcarousel__element__review__star" />
                                                                    <div className="tripcarousel__element__review-inner">
                                                                        {trip.review_average}
                                                                    </div>
                                                                </>
                                                            }
                                                        </div>
                                                        {trip.settings.paid && trip.settings.price && trip.settings.price > 0 &&
                                                            <div className="tripcarousel__element__price text-bold">
                                                                {format_price(parseInt(trip.settings.price))}
                                                            </div>
                                                        }
                                                        {!(trip.settings.paid && trip.settings.price && trip.settings.price > 0) &&
                                                            <div className="tripcarousel__element__price text-bold text-color-primary">
                                                                {"Free"}
                                                            </div>
                                                        }
                                                    </div>
                                                    {((trip.cities && trip.cities.length >= 1) || (trip.countries && trip.countries.length >= 1)) &&
                                                        <div className="tripcarousel__element__contentbox tripcarousel__element__contentbox-flex">
                                                            <div className="tripcarousel__element__contentbox__icon">
                                                                <IconLocation className="tripcarousel__element__contentbox__icon-inner" />
                                                            </div>
                                                            <div className="tripcarousel__element__contentbox__label tripcarousel__element__contentbox__label--doubleline">
                                                                {trip.cities && trip.cities.length >= 1 &&
                                                                    <div className="tripcarousel__element__contentbox__label__element">
                                                                        {trip.cities.length > 1
                                                                            ? (trip.cities.join(" | "))
                                                                            : (trip.cities[0])
                                                                        }
                                                                    </div>
                                                                }
                                                                {trip.countries && trip.countries.length >= 1 &&
                                                                    <div className="tripcarousel__element__contentbox__label__element">
                                                                        {trip.countries.length > 1
                                                                            ? (trip.countries.join(" | "))
                                                                            : (trip.countries[0])
                                                                        }
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>
                                                    }
                                                    {(trip.target || trip.category) &&
                                                        <div className="tripcarousel__element__contentbox tripcarousel__element__contentbox-flex">
                                                            <div className="tripcarousel__element__contentbox__icon">
                                                                <IconCouple className="tripcarousel__element__contentbox__icon-inner tripcarousel__element__contentbox__icon-inner--large" />
                                                            </div>
                                                            <div className="tripcarousel__element__contentbox__label">
                                                                <div className="tripcarousel__element__contentbox__label__element">
                                                                    {trip.target.concat(trip.category).join(" | ")}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    }
                                                    {(trip.activities_count && trip.activities_count >= 1) &&
                                                        <div className="tripcarousel__element__contentbox tripcarousel__element__contentbox-flex">
                                                            <div className="tripcarousel__element__contentbox__icon">
                                                                <IconDetails className="tripcarousel__element__contentbox__icon-inner" />
                                                            </div>
                                                            <div className="tripcarousel__element__contentbox__label">
                                                                {(trip.activities_count + " activities") + (trip.pricing ? " | " + trip.pricing[0] : "")}
                                                            </div>
                                                        </div>
                                                    }

                                                    {trip.description && trip.description.length >= 1 && trip.description[0].description &&
                                                        <div className="tripcarousel__element__contentbox tripcarousel__element__textbox">
                                                            {trip.description[0]["content"].split(/\s+/).slice(0, 20).join(' ') + " ..."}
                                                        </div>
                                                    }

                                                </div>
                                            </div>
                                        )
                                    ))}

                                    {(!this.state.trip_data || this.state.trip_data.length <= 0) && !this.state.data_loaded_completed && [0, 1, 2, 3, 4, 5, 6, 7].map((index) => (
                                        <div key={index} className="search__results__element search__results__element--skeleton"></div>
                                    ))}

                                </div>
                            }


                            {this.state.trip_data.length < 1 && this.state.data_loaded_completed && 
                                <div className="search__results__textbox text-subtitle">
                                    We could not find the trip you are looking for. {/* How about the following? */}

                                    {/* <Destinationcarousel
                                        label={"We could not find the trip you are looking for. How about the following?"}
                                    /> */}
                                </div>
                            }


                        </div>
                    </div>
                </div>

                {/* Popups for editing */}
                {this.state.page !== "" &&
                    <div className="search__overlay"></div>
                }

                {/* Filter countries */}
                {this.state.page === "country" &&
                    <div className="trip__popup-container">
                        <div className="trip__popup">
                            <div className="trip__popup__close-wrapper">
                                <IconClose onClick={() => this.setPage("")} className="trip__popup__close" />
                            </div>
                            <div className="trip__popup__section">
                                <div className="account__element">
                                    <ForminputDropdown
                                        name={"country"}
                                        label={"Country"}
                                        placeholder={"Destination country"}
                                        list={Object.keys(this.props.locations)}
                                        setFormValue={this.addFilterElement.bind(this)}
                                        required={false}
                                    />
                                </div>
                                {this.state.filters.country.length >= 1 &&
                                    <div className="trip__popup__element labelbar">
                                        {this.state.filters.country.map((country, index) => (
                                            <div key={index} onClick={() => this.removeFilterElement("country", country)} className="label">
                                                {country}
                                            </div>
                                        ))}
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                }

                {/* Filter cities */}
                {this.state.page === "city" &&
                    <div className="trip__popup-container">
                        <div className="trip__popup">
                            <div className="trip__popup__close-wrapper">
                                <IconClose onClick={() => this.setPage("")} className="trip__popup__close" />
                            </div>
                            <div className="trip__popup__section">
                                <div className="account__element">
                                    <ForminputDropdown
                                        name={"city"}
                                        label={"City"}
                                        placeholder={"Destination cities"}
                                        list={this.state.filters.country.flatMap(country => this.props.locations[country] || [])}
                                        setFormValue={this.addFilterElement.bind(this)}
                                        required={false}
                                    />
                                </div>
                                {this.state.filters.city.length >= 1 &&
                                    <div className="trip__popup__element labelbar">
                                        {this.state.filters.city.map((city, index) => (
                                            <div key={index} onClick={() => this.removeFilterElement("city", city)} className="label">
                                                {city}
                                            </div>
                                        ))}
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                }

                {/* Filter radius */}
                {this.state.page === "radius" &&
                    <div className="trip__popup-container">
                        <div className="trip__popup">
                            <div className="trip__popup__close-wrapper">
                                <IconClose onClick={() => this.setPage("")} className="trip__popup__close" />
                            </div>
                            <div className="trip__popup__section">
                                <div className="trip__popup__element labelbar">
                                    {this.state.radius_list.map((radius, index) => (
                                        <div key={index} onClick={() => this.setFilter("radius", radius)} className={"label" + (this.state.filters.radius == radius ? " label--selected" : " label--unselected")}>
                                            {radius + " km"}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                }

                {/* Filter categories */}
                {this.state.page === "category" &&
                    <div className="trip__popup-container">
                        <div className="trip__popup">
                            <div className="trip__popup__close-wrapper">
                                <IconClose onClick={() => this.setPage("")} className="trip__popup__close" />
                            </div>
                            <div className="trip__popup__section">
                                <div className="trip__popup__element labelbar">
                                    {this.props.trip_categories.map((category, index) => (
                                        <div key={index} onClick={() => this.toggleFilterElement("category", category)} className={"label" + (this.state.filters.category.includes(category) ? " label--selected" : " label--unselected")}>
                                            {category}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                }

                {/* Filter target groups */}
                {this.state.page === "size" &&
                    <div className="trip__popup-container">
                        <div className="trip__popup">
                            <div className="trip__popup__close-wrapper">
                                <IconClose onClick={() => this.setPage("")} className="trip__popup__close" />
                            </div>
                            <div className="trip__popup__section">
                                <div className="trip__popup__element labelbar">
                                    {this.props.trip_targets.map((size, index) => (
                                        <div key={index} onClick={() => this.toggleFilterElement("size", size)} className={"label" + (this.state.filters.size.includes(size) ? " label--selected" : " label--unselected")}>
                                            {size}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                }

                {/* Filter pricing */}
                {this.state.page === "pricing" &&
                    <div className="trip__popup-container">
                        <div className="trip__popup">
                            <div className="trip__popup__close-wrapper">
                                <IconClose onClick={() => this.setPage("")} className="trip__popup__close" />
                            </div>
                            <div className="trip__popup__section">
                                <div className="trip__popup__element labelbar">
                                    {this.props.trip_pricing.map((pricing, index) => (
                                        <div key={index} onClick={() => this.toggleFilterElement("pricing", pricing)} className={"label" + (this.state.filters.pricing.includes(pricing) ? " label--selected" : " label--unselected")}>
                                            {pricing}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                }

                {/* Filter timing */}
                {this.state.page === "timing" &&
                    <div className="trip__popup-container">
                        <div className="trip__popup">
                            <div className="trip__popup__close-wrapper">
                                <IconClose onClick={() => this.setPage("")} className="trip__popup__close" />
                            </div>
                            <div className="trip__popup__section">
                                <div className="trip__popup__element labelbar">
                                    {this.props.trip_timing.map((timing, index) => (
                                        <div key={index} onClick={() => this.toggleFilterElement("timing", timing)} className={"label" + (this.state.filters.timing.includes(timing) ? " label--selected" : " label--unselected")}>
                                            {timing}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                }

                {/* Filter for following status */}
                {this.state.page === "following" &&
                    <div className="trip__popup-container">
                        <div className="trip__popup">
                            <div className="trip__popup__close-wrapper">
                                <IconClose onClick={() => this.setPage("")} className="trip__popup__close" />
                            </div>
                            <div className="trip__popup__section">
                                <div className="trip__popup__element labelbar">
                                    <div onClick={() => this.setFilter("following", "all")} className={"label" + (this.state.filters.following == "all" ? " label--selected" : " label--unselected")}>
                                        From all users
                                    </div>
                                    <div onClick={() => this.setFilter("following", "following")} className={"label" + (this.state.filters.following == "following" ? " label--selected" : " label--unselected")}>
                                        From users I follow
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }

                {/* Sort order */}
                {this.state.page === "sort" &&
                    <div className="trip__popup-container">
                        <div className="trip__popup">
                            <div className="trip__popup__close-wrapper">
                                <IconClose onClick={() => this.setPage("")} className="trip__popup__close" />
                            </div>
                            <div className="trip__popup__section">
                                <div className="trip__popup__element labelbar">
                                    <div onClick={() => this.setSort("rated")} className={"label" + (this.state.sort == "rated" ? " label--selected" : " label--unselected")}>
                                        Recommended
                                    </div>
                                    <div onClick={() => this.setSort("views")} className={"label" + (this.state.sort == "views" ? " label--selected" : " label--unselected")}>
                                        Most views
                                    </div>
                                    <div onClick={() => this.setSort("newest")} className={"label" + (this.state.sort == "newest" ? " label--selected" : " label--unselected")}>
                                        Newest
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }

            </div>
        )
    }
}

export default withRouter(Search);